import { useState } from 'react'
import emailjs from '@emailjs/browser'
emailjs.init("user_fIT3MWHY8wRA5ECtHcXll")

const current = new Date();
const year = `${current.getFullYear()}`;

const initialState = {
  name: '',
  email: '',
  message: '',
}
export const Contact = (props) => {
  const [{ name, email, message }, setState] = useState(initialState)

  const handleChange = (e) => {
    const { name, value } = e.target
    setState((prevState) => ({ ...prevState, [name]: value }))
  }
  const clearState = () => setState({ ...initialState })
  const alertme = document.getElementById("alertme")
  const loadme = document.getElementById("loadme")
  
  function hideAlert() {
  loadme.style.display = 'none';
  alertme.style.display = 'none';
  console.log("message appeared");
  }
    
  const handleSubmit = (e) => {
    e.preventDefault()
    loadme.style.display = 'inline-block';
    loadme.innerHTML = "<img src='img/loadme.gif'>"
    console.log(name, email, message)
    emailjs
      .sendForm(
        'service_083vxmz', 'contact_form', e.target, 'user_fIT3MWHY8wRA5ECtHcXll'
      )
      .then(
        (result) => {
          console.log(result.text)
          clearState()
          e.target.reset()
          loadme.innerHTML = ""
          alertme.style.display = 'inline-block';
          setTimeout(hideAlert, 6000);
        },
        (error) => {
          console.log(error.text)
        }
      )
  }
  return (
    <div>
      <div id='contact'>
        <div className='container'>
          <div className='col-md-8'>
            <div className='row'>
              <div className='section-title'>
                <h2>Get In Touch</h2>
                <p>
                  Please fill out the form below to send us a message and we will
                  get back to you as soon as possible.
                </p>
              </div>
              <form name='sentMessage' validate onSubmit={handleSubmit}>
                <div className='row'>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='text'
                        id='name'
                        name='name'
                        className='form-control'
                        placeholder='Name'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                  <div className='col-md-6'>
                    <div className='form-group'>
                      <input
                        type='email'
                        id='email'
                        name='email'
                        className='form-control'
                        placeholder='Email'
                        required
                        onChange={handleChange}
                      />
                      <p className='help-block text-danger'></p>
                    </div>
                  </div>
                </div>
                <div className='form-group'>
                  <textarea
                    name='message'
                    id='message'
                    className='form-control'
                    rows='4'
                    placeholder='Message'
                    required
                    onChange={handleChange}
                  ></textarea>
                  <p className='help-block text-danger'></p>
                </div>
                <div id='success'></div>
                <button type='submit' className='btn btn-custom btn-lg'>
                  Send Message
                </button><span id="loadme"></span><span id="alertme"><i className='fa fa-check'></i> Message Sent</span>
              </form>
            </div>
          </div>
          <div className='col-md-3 col-md-offset-1 contact-info'>
            <div className='contact-item'>
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className='fa fa-globe'></i> Website
                </span>
                <a target="_blank" href={props.data ? props.data.address : 'loading'}>Crispr Science Website</a>
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-phone'></i> Phone
                </span>{' '}
                <a target="_blank" href={props.data ? props.data.phone : 'loading'}>Call Support</a>
              </p>
            </div>
            <div className='contact-item'>
              <p>
                <span>
                  <i className='fa fa-envelope-o'></i> Email
                </span>{' '}
                <a target="_blank" href={props.data ? props.data.email : 'loading'}>Email Us</a>
              </p>
            </div>
          </div>
          <div className='col-md-12'>
            <div className='row'>
              <div className='social'>
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : '/'}>
                      <i className='fa fa-facebook'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : '/'}>
                      <i className='fa fa-twitter'></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.instagram : '/'}>
                      <i className='fa fa-instagram'></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id='footer'>
        <div className='container text-center'>
          <p>
            &copy; {year} Crisprcoin Token. Learn more info about {' '}
            <a href='https://crisprscience.net' target='_blank'>
              Crispr Science
            </a>
          </p>
        </div>
      </div>
    </div>
  )
}
